import React from 'react';

import { Sidebar } from "../../components";

import './dashboard.scss';

const ViewDashboard = (props: any) => {

  return (
    <div className="view_dashboard">
      <Sidebar />
      <div className='dashboard_content'>
        {props.children}
      </div>
    </div>
  );
};

export default ViewDashboard;